import { MenuItem, TextField, Typography } from '@mui/material';
import { DealerLocationOption } from 'modules/integrationSettings/hooks/useDealerLocations';

interface Props {
  accountId: string;
  value: string;
  options: DealerLocationOption[];
  isLoading: boolean;
  onChange: (locationId: string) => void;
}

export const DealerLocationSelect = ({ accountId, value, options, isLoading, onChange }: Props) => {
  const selectedValue = options.some(option => option.locationId === value) ? value : '';

  return (
    <TextField
      select
      fullWidth
      label="Location"
      value={selectedValue}
      disabled={!accountId || isLoading}
      onChange={event => onChange(event.target.value)}
      InputLabelProps={{ shrink: true }}
      SelectProps={{
        displayEmpty: true,
        renderValue: selected => {
          const option = options.find(item => item.locationId === selected);
          return option ? (
            option.locationName
          ) : (
            <Typography component="span" color="text.disabled">
              Not required
            </Typography>
          );
        },
      }}
    >
      <MenuItem value="">
        <em>None</em>
      </MenuItem>
      {options.map(option => (
        <MenuItem key={option.locationId} value={option.locationId}>
          {option.locationName}
        </MenuItem>
      ))}
    </TextField>
  );
};
